<div class="wrapper d-flex">

    <div class=" cash-register-wrapper p-4 d-flex align-items-center justify-content-center">
        <!-- <fa-icon class="exit-icon" [icon]='faXmark' (click)="close()"></fa-icon> -->
        <div class="row align-items-center justify-content-center">
            <div class="col-12">
                <p class="title m-0" style="margin-bottom: 25px !important;">Selecciona la caja que quieres abrir:</p>
            </div>
            <div class="grid-cash-registers col-12">
                <div class="mt-2 d-flex justify-content-center align-items-center item-cash-register"
                    style="cursor: pointer;" *ngFor="let cashregister of cashRegisters"
                    (click)="selectCashRegister(cashregister)">
                    <div class=" cash-register-card d-flex align-items-center ">
                        {{cashregister.name}}
                    </div>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-center">
                <span class="m-0 secondary-button " (click)="viewReports()"
                    style="  margin-top: 50px !important; padding: 10px 20px; cursor: pointer; cursor: pointer;">
                    <span><fa-icon style="margin-right: 10px; font-size: 20px;" [icon]='faReport'></fa-icon></span>Ver
                    informes de transacciones - Histórico</span>
            </div>
        </div>
    </div>
</div>